{
  "arsiv": {
    "Baslik": "Arşiv",
    "Ekle": "Yeni Ekle",
    "Filtrele": "Filtrele",
    "Data Yenile": "Verileri Güncelle",
    "Duzenle": "Düzenle",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Tur": "Tür",
    "Ad": "Ad",
    "Link/Dosya": "Link / Dosya",
    "Link": "Link",
    "Dosya": "Dosya",
    "Durum": "Durum",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Hepsi": "Hepsi",
    "Dosya Adi": "Dosya Adı",
    "Link Yaz": "Link Yaz",
    "Dosya Yukle": "Dosya Yükle",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Vazgec": "Vazgeç",
    "ARA": "Ara"
  }
}
